<template>
  <div class="container">
    <NicoHeader model-type="1" :brand-image="tagDetail.brandPicture "/>

    <div class="w-full" style="background: #2f2f2f;height:1px;margin-top:38px"></div>

    <NicoDevice v-if="tagDetail" :device-info="tagDetail" @onFavoriteDevice="onFavoriteDevice"/>

    <div class="ml-6 mr-6 mt-6" v-show="tagDetail.voltageCurveList && tagDetail.voltageCurveList.length > 0">
      <div class="horizontal items-center justify-round full-width justify-items-center">

        <div class="flex-1 vertical items-center justify-center text-white"
            v-for="(item,index) in tagDetail.voltageCurveList" @click="onFavoriteCurve(item,index)">
          <div class="horizontal items-center gap-1">
            <van-image :src="item.isFavorite === 0 ? unlikeIcon:likeIcon"/>
            <div style="height:15px;line-height: 15px;" class="horizontal items-center justify-center">{{ item.favoriteCount > 99 ? "99+" : item.favoriteCount }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="ml-6 mr-6 mt-2" v-if="tagDetail.voltageCurveList && tagDetail.voltageCurveList.length > 0">
      <NicoSlider @click="onCurveClick" :disabled="disabledNfcButton" :selected-item="selectedCurveIndex"/>
    </div>

    <div class="horizontal items-center operate-wrap">
      <div class="horizontal items-center justify-center verify-bg" @click="onVerifyDeviceClick">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
            width="17.5" height="17.5" viewBox="0 0 17.5 17.5">
          <g>
            <path
                d="M7.875,1.75C4.49226,1.75,1.75,4.49226,1.75,7.875C1.75,11.2578,4.49226,14,7.875,14C9.52516,14,11.023,13.3474,12.1243,12.2862C12.1474,12.2563,12.1726,12.2274,12.2,12.2C12.2274,12.1726,12.2563,12.1474,12.2862,12.1243C13.3474,11.023,14,9.52516,14,7.875C14,4.49226,11.2578,1.75,7.875,1.75C7.875,1.75,7.875,1.75,7.875,1.75ZM14.0279,12.7905C15.1056,11.4432,15.75,9.73438,15.75,7.875C15.75,3.52576,12.2243,0,7.875,0C3.52576,0,0,3.52576,0,7.875C0,12.2243,3.52576,15.75,7.875,15.75C9.73438,15.75,11.4432,15.1056,12.7905,14.0279C12.7905,14.0279,16.0063,17.2437,16.0063,17.2437C16.348,17.5854,16.902,17.5854,17.2437,17.2437C17.5854,16.902,17.5854,16.348,17.2437,16.0063C17.2437,16.0063,14.0279,12.7905,14.0279,12.7905C14.0279,12.7905,14.0279,12.7905,14.0279,12.7905Z"
                fill-rule="evenodd" fill="#FFFFFF" fill-opacity="1"/>
          </g>
        </svg>
        <span class="ml-1">VERIFY</span>
      </div>
      <button class="bg-white connect-btn ml-6"
          :class="disabledNfcButton ? 'disabled':''"
          @click="onRead(false)"
          :disabled="disabledNfcButton">CONNECT
      </button>
    </div>

    <PopupCaptcha v-model="showCaptchaPopup" :captcha="captcha" :captcha-image="captchaImage"
        @onRightClick="onCaptchaApply"
        @change="onVerifyDeviceClick" @onCaptchaChange="onCaptchaChange"/>
    <PopupVerifyResult v-if="verifyDeviceInfo"
        v-model="showVerifyResult"
        :device-info="verifyDeviceInfo"
        @onConfirmClick="onCheckAnotherOne"/>


    <PopupDeviceCurve
        show-button
        v-if="!legalDevice"
        v-model="showNfcScanResult"
        :loading="tagInfoLoading"
        :ingredient-text="ingredientsText"
        :legal-device="legalDevice"
        :tag-id="tagId"
        :device-name="(tagDetail && tagDetail.deviceName) || ''"/>

    <NFCPopup v-model="showNfcPopup" :msg="androidPopupMsg"/>

  </div>
</template>

<script>
import NicoHeader from "@/components/home/NicoHeader.vue";
import NicoDevice from "@/components/nico/NicoDevice.vue";
import NicoSlider from "@/components/nico/NicoSlider.vue";
import PopupCaptcha from "@/components/nico/PopupCaptcha.vue";
import PopupVerifyResult from "@/components/nico/PopupVerifyResult.vue";
import {
  calcPower,
  calcVoltageFloorInt,
  checkDeviceLegal,
  convertTagId,
  findDeviceR,
  isAndroid,
  THC
} from "@/util/utils";
import log from "@/util/log";
import nfcRepository from "@/nfc/NFCRepository";
import { SUFFIX_FLAG, WriterSetting } from "@/bluetooth/BluetoothData";
import user from "@/api/user";
import device from "@/api/device";
import { mapState } from "vuex";
import StoreType, { NFC_MODULE_NAME } from "@/store/StoreType";
import userMixin from "@/mixins/userMixin";
import DialogTips from "@/components/DialogTips.vue";
import PopupDeviceCurve from "@/components/PopupDeviceCurve.vue";
import NFCPopup from "@/components/nfc/NFCPopup.vue";

export default {
  name: "NicoHome",
  mixins: [userMixin],
  components: {
    NFCPopup,
    PopupDeviceCurve,
    DialogTips,
    PopupVerifyResult,
    PopupCaptcha,
    NicoSlider,
    NicoDevice,
    NicoHeader
  },
  data() {
    return {
      showCaptchaPopup: false,
      showVerifyResult: false,
      tagDetail: {
        isDefaultData: true,
        flavorName: "Strawberry Ice",
        flavorPicture: require("@/assets/icons/nico/ic_default_device.svg"),
        battery: "100",
        liquid: "99"
      },

      tagInfoLoading: false,
      showNfcScanResult: false,
      disabledNfcButton: false,

      ingredientsText: "",

      androidPopupMsg: {
        title: "Ready to Read",
        message: "Place your product in the NFC area"
      },
      typeOfDevice: 1,
      legalDevice: false,
      verifyDeviceInfo: null,
      captchaImage: null,

      showTips: false,
      tipsMessage: "",

      captcha: "",

      selectedCurveIndex: 0,
      prevSelectedCurveIndex: 0,

      isOperateNFCSuccess: false,
      powers: [[1, 4.2], [2, 3.8], [3, 1.8], [4, 4.3], [5, 4.5], [6, 8.5], [7, 6.5], [8, 6.1]],


      showNfcPopup: false,
      unlikeIcon: require("@/assets/icons/nico/ic_like_curve_normal.svg"),
      likeIcon: require("@/assets/icons/nico/ic_like_curve_active.svg"),

      showLogoutPopup: false,
      tagId: ''
    };
  },
  methods: {
    onCaptchaChange(e) {
      this.captcha = e;
    },
    async onFavoriteDevice() {
      try {
        const isFavorite = this.tagDetail.isFavorite === 1;

        const resp = await user.favoriteDevice({
          isFavorite: isFavorite ? 0 : 1,
          tag: this.tagDetail.tagId
        });
        if (resp.code !== 200) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }
        this.tagDetail.isFavorite = isFavorite ? 0 : 1;
        this.cacheTagData(this.tagDetail);
        this.$toast({
          type: "success",
          message: resp.message
        });
      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }
    },
    onCurveClick(index) {
      if (!this.tagDetail || !this.tagDetail.voltageCurveList || this.tagDetail.voltageCurveList.length === 0) {
        return;
      }
      this.selectedCurveIndex = index;
      const item = this.tagDetail.voltageCurveList[index];
      const voltages = item.heatingVoltage.split(",");

      const maxPower = calcPower(this.maxVoltage, this.r, 10);
      voltages.forEach((item, index) => {
        this.powers[index][1] = calcPower(item, this.r, maxPower);
      });

      this.$set(this.powers, 0, this.powers[0]);
      this.onWrite(item.position);
    },
    changeCaptcha() {
      const uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
      this.captchaImage = `${process.env.NODE_ENV === "dev" ? "/api" : "/supplement"}/omni/user/captcha?id=${uuid}`;
    },
    onVerifyDeviceClick() {
      this.changeCaptcha();
      this.showCaptchaPopup = true;

      // this.showVerifyResult = true;
    },
    async onCaptchaApply(captcha) {
      try {
        let resp = await user.checkUserCaptcha({
          verificationCode: captcha
        });
        if (resp.code !== 200) {
          this.$toast({
            message: resp.message
          });
          this.changeCaptcha();
          return;
        }
        this.showCaptchaPopup = false;

        await this.verifyTag(this.tagDetail.tagId);

      } catch (e) {
        console.log(e);
      }

    },
    onCheckAnotherOne() {
      this.onRead(true);
    },

    showCaptchaResultPopup() {
      this.showVerifyResult = true;
    },

    async onFavoriteCurve(item, index) {
      try {

        // item.isFavorite = item.isFavorite ? 0 : 1;
        // const isFavorite = item.isFavorite === 1;
        // if (isFavorite) {
        //   item.favoriteCount += 1;
        // } else {
        //   item.favoriteCount -= 1;
        // }
        // this.$set(this.tagDetail.voltageCurveList, index, item);


        const resp = await user.favoriteRecommendCurve({
          id: item.id,
          isFavorite: item.isFavorite ? 0 : 1
        }, true);
        if (resp.code != 200) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }


        item.isFavorite = item.isFavorite ? 0 : 1;
        const isFavorite = item.isFavorite === 1;
        if (isFavorite) {
          item.favoriteCount += 1;
        } else {
          item.favoriteCount -= 1;
        }
        this.$set(this.tagDetail.voltageCurveList, index, item);

        this.cacheTagData(this.tagDetail);
      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }
    },

    async verifyTag(tagId) {
      const resp = await user.verifyTag({ tagId }, true);
      if (resp.code !== 200) {
        this.showNfcScanResult = true;
        this.legalDevice = false;
        return false;
      }

      this.handleVerifyDeviceInfo(resp.data);

      this.showVerifyResult = true;

      return true;
    },
    getVoltages() {
      return this.powers.map((item) => {
        return calcVoltageFloorInt(item[1], this.r);
      });
    },
    //NFC监听
    getNFCReader(isRead = true) {
      if (this.disabledNfcButton) {
        return null;
      }
      const nfcReader = navigator.nfcReader;
      if (!nfcReader) {
        this.$dialog.alert({
          message: "Current environment not support this function,Please download app to use it"
        });
        return null;
      }

      if (!this.isInitErrorHandler) {
        nfcReader.addEventListener(
            "receiveInvalidateWithError",
            this.handlerNFCError
        );
        this.isInitErrorHandler = true;
      }

      if (!this.isInitBegingEvent) {
        nfcReader.addEventListener(
            "receiveBegingActive",
            this.handleBeingActive
        );
        this.isInitBegingEvent = true;
      }

      if (isRead) {
        this.androidPopupMsg = {
          title: "Ready to Read",
          message: "Place your product in the NFC area"
        };
      } else {
        this.androidPopupMsg = {
          title: "Ready to Write",
          message: "Place your product in the NFC area"
        };
      }

      this.showNfcPopup = isAndroid();
      if (!this.showNfcPopup) {
        this.disabledNfcButton = true;
      }
      return nfcReader;
    },

    handlerNFCError(event) {
      log("出现错误 " + JSON.stringify(event.error));
      if (event.error.errorCode !== 200) {
        // navigator.nfcReader.endReaderSession(false, "");
      }
      if (!this.isOperateNFCSuccess) {
        console.log(`恢复选中状态 ${this.prevSelectedCurveIndex}`);
        this.selectedCurveIndex = this.prevSelectedCurveIndex;
      }
      this.isOperateNFCSuccess = false;
      log(`disabledNfcButton before = ${this.disabledNfcButton}`);
      this.disabledNfcButton = false;
      log(`disabledNfcButton after= ${this.disabledNfcButton}`);
    },
    handleBeingActive(event) {
      log("handleBeingActive ");
      // this.toastObj.clear();
    },

    async onRead(showCaptchaResult = false) {

      // const verifyDeviceInfo = await user.verifyTag({ tagId:"17AA33BE100153E0" }, true);
      // this.handleVerifyDeviceInfo(verifyDeviceInfo)
      // this.showVerifyResult = true
      // return
      if (this.disabledNfcButton) {
        return;
      }

      const nfcReader = this.getNFCReader();
      if (!nfcReader) {
        return;
      }

      const session = await nfcReader.beginReaderSession(2, {
        operate: 2,
        alertMessage: "Place your product in the NFC area."
      });
      log(`tag id = ${session.id}`);

      try {

        await session.connect();
        //
        const { level, groupNumber } = await nfcRepository.readDeviceLevel(session);
        this.level = level;
        const isSupportLevel = (level > 0);

        // const flag = await nfcRepository.readDeviceFlag(session, isSupportLevel);
        // log(`flag = ${flag}`);
        // if (flag !== SUFFIX_FLAG) {
        //   throw ("No support device");
        // }
        //
        const oilBattery = await nfcRepository.readDeviceOilBattery(session);
        const currentVoltages = oilBattery.getBatteryValue(this.typeOfDevice);
        const { currentSeconds, maxSeconds } = oilBattery.getLiquidValue(this.typeOfDevice);
        const batteryPercent = oilBattery.getBatteryPercent(this.typeOfDevice);
        const liquidPercent = oilBattery.getLiquidPercent(this.typeOfDevice);
        console.log(`battery percent = ${batteryPercent}`);
        console.log(`liquid percent = ${liquidPercent}`);


        //
        const deviceInfoDataView = await nfcRepository.readDeviceInfo(session, level);
        //
        const typeOfDevice = await nfcRepository.readDeviceType(session);
        this.typeOfDevice = typeOfDevice;
        //
        this.r = findDeviceR(typeOfDevice, groupNumber);
        log(`当前的设备的阻值为 ${this.r}`);
        //
        const maxPower = calcPower(this.maxVoltage, this.r, 12);
        //
        //
        const writerSetting = new WriterSetting(deviceInfoDataView);
        if (isSupportLevel) {
          writerSetting.diyVoltage = writerSetting.diyVoltage.slice((level - 1) * 8, level * 8);
        }
        this.$store.commit(
            `${NFC_MODULE_NAME}${StoreType.COMMIT_TYPE.STATE_CURRENT_WRITER_SETTING}`,
            writerSetting
        );
        //

        writerSetting.diyVoltage.forEach((item, index) => {
          this.powers[index][1] = calcPower(item, this.r, maxPower);
        });

        await this.$store.dispatch("nfc/saveCurve", this.powers);
        // //强制刷新组件的props，里面用到了computed
        // this.$set(this.powers, 0, this.powers[0]);
        //
        // log(`读取的电压为 ： ${writerSetting.diyVoltage}`);
        // log(`读取的功率为 ： ${this.powers}`);

        const tagId = convertTagId(session.id);
        this.tagId = tagId;

        this.tagInfoLoading = true;


        nfcReader.endReaderSession(true, "Read Success!");


        try {
          let tagInfo;
          if (showCaptchaResult) {
            const result = await this.verifyTag(tagId);
            if (!result) {
              return;
            }
          }
          tagInfo = await user.tagDetail({ tagId }, false);

          this.legalDevice = checkDeviceLegal(tagInfo,this.isBrandUser)
          if (!this.legalDevice) {
            this.tagInfoLoading = false;

            this.showNfcScanResult = true;
            return;
          }

          gtag("event", "read-device", {
            'event_category': 'nfc',
            'event_label': 'read-button',
            'value': {
              isBrand: this.isBrandUser,
              brandName: tagInfo.brandName,
              flavor: tagInfo.flavorName
            }
          });
          tagInfo.tagId = tagId;
          tagInfo.battery = batteryPercent;
          tagInfo.liquid = liquidPercent;
          tagInfo.currentSeconds = currentSeconds;
          this.setAndUploadData(tagInfo);
          this.$store.dispatch("nfc/uploadUserUsageHistory", {
            tagId,
            battery: currentVoltages,
            currentSeconds: currentSeconds,
            maxSeconds: maxSeconds
          });
        } catch (e) {
          log(e);
        } finally {
        }
      } catch (e) {
        log(e);
        if (e instanceof Error) {
          nfcReader.endReaderSession(false, e.message);
        } else {
          nfcReader.endReaderSession(false, e);
        }
      } finally {
        if (this.showNfcPopup) {
          this.showNfcPopup = false;
          this.disabledNfcButton = false;
        }
      }

      log(`开始读取设备`);
    },
    async onWrite(curveLevel) {
      if (this.disabledNfcButton) {
        return;
      }

      const nfcReader = this.getNFCReader(false);
      if (!nfcReader) {
        return;
      }

      let tagId = null;
      const voltages = this.getVoltages();
      try {
        const session = await nfcReader.beginReaderSession(2, {
          operate: 2,
          alertMessage: "Please move your device near the top your phone to write device."
        });
        tagId = convertTagId(session.id);

        await session.connect();

        const { level, groupNumber } = await nfcRepository.readDeviceLevel(session);
        this.level = level;
        const isSupportLevel = (level > 0);

        const flag = await nfcRepository.readDeviceFlag(session, isSupportLevel);
        log(`flag = ${flag}`);
        if (flag !== SUFFIX_FLAG) {
          throw ("No support device");
        }

        const oilBattery = await nfcRepository.readDeviceOilBattery(session);
        const currentVoltages = oilBattery.getBatteryValue(this.typeOfDevice);
        const { currentSeconds, maxSeconds } = oilBattery.getLiquidValue(this.typeOfDevice);
        const batteryPercent = oilBattery.getBatteryPercent(this.typeOfDevice);
        const liquidPercent = oilBattery.getLiquidPercent(this.typeOfDevice);
        console.log(`battery percent = ${batteryPercent}`);
        console.log(`liquid percent = ${liquidPercent}`);


        const typeOfDevice = await nfcRepository.readDeviceType(session);

        this.r = findDeviceR(typeOfDevice, groupNumber);
        log(`当前的设备的阻值为 ${this.r}`);

        const maxPower = calcPower(this.maxVoltage, this.r, 10);
        const writerSetting = new WriterSetting();
        writerSetting.diyVoltage = voltages;

        writerSetting.diyVoltage.forEach((item, index) => {
          this.powers[index][1] = calcPower(item, this.r, maxPower);
        });
        await this.$store.dispatch("nfc/saveCurve", this.powers);

        if (isSupportLevel) { //设备支持档位的，根据推荐曲线来
          const writeLevel = curveLevel > 0 && curveLevel < 4 ? curveLevel : level; //判断推荐曲线的值，超过了使用设备里面的
          await nfcRepository.writeDeviceCurve(session, writerSetting, writeLevel);
          await nfcRepository.writeDeviceLevel(session, curveLevel, groupNumber);
          console.log(writeLevel);
        } else {
          await nfcRepository.writeDeviceCurve(session, writerSetting, level);
        }
        this.prevSelectedCurveIndex = this.selectedCurveIndex;

        nfcReader.endReaderSession(true, "Write success");

        gtag("event", "write-device");
        this.isOperateNFCSuccess = true;
        try {
          const tagInfo = await user.tagDetail({ tagId }, true);

          tagInfo.tagId = tagId;
          tagInfo.battery = batteryPercent;
          tagInfo.liquid = liquidPercent;
          tagInfo.currentSeconds = currentSeconds;
          this.legalDevice = checkDeviceLegal(tagInfo,this.isBrandUser)
          if (!this.legalDevice) {
            this.tagInfoLoading = false;
            this.showNfcScanResult = true;
            return;
          }

          gtag("event", "read-device", {
            'event_category': 'nfc',
            'event_label': 'read-button',
            'value': {
              isBrand: this.isBrandUser,
              brandName: tagInfo.brandName,
              flavor: tagInfo.flavorName
            }
          });
          this.setAndUploadData(tagInfo);
          this.uploadTagData(tagId, writerSetting, maxPower, currentVoltages, currentSeconds, maxSeconds);
        } catch (e) {
          console.log(e);
          log(e);
        } finally {
        }
      } catch (e) {
        if (isAndroid()) {
          this.$toast({
            type: "fail",
            message: e,
            duration: 2000
          });
        }
        this.isOperateNFCSuccess = false;
        nfcReader.endReaderSession(false, e);
      } finally {
        if (this.showNfcPopup) {
          this.showNfcPopup = false;
          this.disabledNfcButton = false;
        }
      }
    },
    setAndUploadData(tagInfo) {
      //为空或者长度为0
      // const combineList = [].concat(tagInfo.ingredientsVoList).concat(tagInfo.terpenesList)
      //     .sort((prev, current) => {
      //       return current.proportion - prev.proportion;
      //     });
      //
      // this.ingredientsText = combineList.map(item => `${item.proportion}% ${item.name}`).join("+");
      this.tagInfoLoading = false;
      this.cacheTagData(tagInfo);
      // this.tagInfoLoading = true;
      //tagInfo.brandName.toLowerCase() !== "zofo"
      if (tagInfo.oilType === THC) {
        this.$router.push({
          name: "Enterprise",
          params: {
            writerSetting: this.writerSetting
          }
        });
        return;
      }
      this.tagDetail = tagInfo;
    },

    uploadTagData(tagId, writerSetting, maxPower, currentVoltages, currentSeconds, maxSeconds) {
      //上传到服务器
      device.uploadConfig(
          (this.consumerCurve && this.consumerCurve.id) || 0,
          (this.consumerCurve && this.consumerCurve.modeName) || "Customizer",
          this.r,
          maxPower,
          null,
          null,
          null,
          navigator.bluetooth2 ? process.env.APP_ANDROID_VERSION : process.env.APP_IOS_VERSION,
          writerSetting,
          tagId,
          null
      );

      this.$store.dispatch("nfc/uploadUserUsageHistory", {
        tagId,
        battery: currentVoltages,
        currentSeconds: currentSeconds,
        maxSeconds: maxSeconds
      });
    },

    cacheTagData(tagDetail) {
      if (this.isBrandUser) {
        this.$store.commit("nfc/setDefaultBusinessTagData", tagDetail);
      } else {
        this.$store.commit("nfc/setDefaultConsumerTagData", tagDetail);
      }
      this.showUserGuide = false;
      this.$store.dispatch("bluetooth/setShowBtGuide", true);
    },
    loadCacheDeviceInfo() {
      const defaultHomeData = this.isBrandUser ? this.defaultBHomeData : this.defaultCHomeData;
      if (!!defaultHomeData) {
        this.legalDevice = true;

        const tagId = defaultHomeData.tagId;
        this.tagId = tagId;
        this.tagDetail = defaultHomeData;

        new Promise(async (resolve, reject) => {
          const tagInfo = await user.tagDetail({ tagId }, false);
          if (tagInfo.id) {

            tagInfo.tagId = tagId;
            tagInfo.battery = defaultHomeData.battery;
            tagInfo.liquid = defaultHomeData.liquid;
            tagInfo.currentSeconds = defaultHomeData.currentSeconds;
            this.tagDetail = {...this.tagDetail,...tagInfo}
            this.cacheTagData(tagInfo);
            // if (tagInfo.brandName.toLowerCase() !== "zofo") {
            if (tagInfo.oilType === THC) {
              this.$router.push({
                name: "Enterprise",
                params: {
                  writerSetting: this.writerSetting
                }
              });
              return;
            }
          }
          resolve();
        });


        return;
      }
    },
    handleVerifyDeviceInfo(verifyDeviceInfo) {
      verifyDeviceInfo.items = [
        {
          key: "Brand",
          value: verifyDeviceInfo.brandName
        }, {
          key: "Product Name",
          value: verifyDeviceInfo.deviceName
        }, {
          key: "Product Id",
          value: verifyDeviceInfo.tag
        }, {
          key: "Query Times",
          value: verifyDeviceInfo.queryCount
        }, {
          key: "Last Query Time",
          value: verifyDeviceInfo.lastQueryTime
        }
      ];
      this.verifyDeviceInfo = verifyDeviceInfo;
    }
  },
  computed: {
    ...mapState("nfc", ["defaultBHomeData", "defaultCHomeData", "writerSetting"])
  },
  watch: {
    showNfcPopup(val) {
      if (!val && isAndroid()) {
        if (!this.isOperateNFCSuccess) {
          console.log(`恢复选中状态 ${this.prevSelectedCurveIndex}`);
          this.selectedCurveIndex = this.prevSelectedCurveIndex;
        }
        this.isOperateNFCSuccess = false;
      }
    }
  },
  mounted() {
    this.loadCacheDeviceInfo();
  },
  activated() {
    localStorage.setItem("last_path", "nico");
    this.loadCacheDeviceInfo();
    this.showUserGuide = true;//await this.$store.dispatch("nfc/checkShowNfcGuide");
    log(this.showUserGuide);
    if (this.isBrandUser) {
      //TODO: 显示年龄认证
    }

  }
};
</script>

<style scoped lang="less">
.container {
  background: black;
}

.operate-wrap {
  font-family: 'outfit';
  font-size: 20px;
  flex:1;
  margin: 0px 24px 0 24px;
}

.verify-bg {
  width: 127px;
  border-radius: 30px;
  height: 46px;
  text-align: center;
  color: white;
  background: #0D0D0D;
  box-shadow: inset 0px 0px 10px 5px rgba(73, 73, 73, 0.6), inset 0px 0px 5px 0px rgba(171, 171, 171, 0.3);
  transition: all 0.3s ease; /* 添加过渡效果 */

  &:active {
    opacity: 0.4;
  }
}

.connect-btn {
  background: white;
  color: #333333;
  flex: 1;
  text-align: center;
  border-radius: 30px;
  height: 46px;
  line-height: 46px;
  transition: all 0.3s ease; /* 添加过渡效果 */

  &:active {
    background: #929292;
  }
}

.disabled {
  background: #929292;
}


</style>